import axios, { AxiosResponse } from 'axios';
import { Localidad, Pais, Provincia  } from './suite.interfaces';
import { CommonService } from './common.services';

export class GeneralService extends CommonService {

  async findPaisesBy(): Promise<Pais[]> {
    try {      
      const response: AxiosResponse<Pais[]> = await axios.get(super.getServerUrl() + '/mobile/findPaisesBy', { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findProvinciasBy(idPais:number): Promise<Provincia[]> {
    try {      
      const response: AxiosResponse<Provincia[]> = await axios.get(super.getServerUrl() + '/mobile/findProvinciasBy?pais=' + idPais, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) { 
      throw super.manageError(error);
    }
  }

    async findLocalidadesBy(idProvincia:number): Promise<Localidad[]> {
    try {      
      const response: AxiosResponse<Localidad[]> = await axios.get(super.getServerUrl() + '/mobile/findLocalidadesBy?provincia=' + idProvincia, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findAllLocalidadesBy(): Promise<Localidad[]> {
    try {      
      const response: AxiosResponse<Localidad[]> = await axios.get(super.getServerUrl() + '/mobile/findAllLocalidadesBy', { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }
}